import { Routes } from '@angular/router';
import { Module, Navigation } from '@core/navigation/navigation.model';
import { authGuard, loginGuard, navigationGuard, relogGuard } from '@core/route.guard';
import { LoginComponent } from '@identity/pages/login/login.component';
import { ErrorComponent } from '@shared/components/error/error.component';
import { ErrorType } from '@shared/components/error/error.model';

export const routes: Routes = 
[
    {
        path: '',
        canDeactivate: [relogGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full',
            },
            {
                path: 'login',
                canMatch: [loginGuard],
                component: LoginComponent
            },
            {
                path: 'user',
                canMatch: [authGuard],
                data: {
                    dataModule: Module.Profile
                },
                loadChildren: () => import('./features/identity/identity.routes').then(mod => mod.routes)
            },
            {
                path: 'manage',
                canMatch: [authGuard, navigationGuard],
                data: {
                    dataNavigation: Navigation.Management,
                    dataModule: Module.Management
                },
                loadChildren: () => import('./features/management/management.routes').then(mod => mod.routes)
            },
            {
                path: 'company',
                canMatch: [authGuard],
                loadChildren: () => import('./features/features.routes').then(mod => mod.routes)
            },
            {
                path: 'organisation',
                canMatch: [authGuard],
                loadChildren: () => import('./features/organisation/organisation.routes').then(mod => mod.routes)
            },
            {
                path: 'access-denied',
                component: ErrorComponent,
                data: {
                    errorType: ErrorType.AccessDenied
                },
            },
            {
                path: '**',
                component: ErrorComponent,
                data: {
                    errorType: ErrorType.NotFound
                },
            }
        ]
    }
    
];